import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

const CustomInput = ({
    id,
    placeholder,
    value,
    onChange,
    keyboardType,
    className,
    autoComplete,
    label,
    icon = null,
    touched,
    errorText,
}) => {
    const [shownPassword, setShownPassword] = useState(false);
    return (
        <div className="w-full flex flex-col gap-2">
            {(label ?? '') !== '' && <div className={`text-[16px] font-semibold text-gray-100`}>{label}</div>}
            <div className="relative w-full bg-white rounded-xl flex items-center gap-4 border border-transparent focus-within:border-gray-400 transition">
                {icon && <div className="pl-3 text-[20px] text-gray-800">
                    {icon}
                </div>}

                <input
                    id={id}
                    placeholder={placeholder ?? ''}
                    value={value}
                    autoComplete={autoComplete}
                    onChange={(e) => onChange?.(e.target.value ?? '')}
                    type={keyboardType === 'password' ? shownPassword ? 'text' : 'password' : (keyboardType ?? "text")}
                    className={`pl-2 pr-4 h-14 border rounded-md text-[16px] font-medium text-gray-600
                    focus:outline-none focus:ring-0 bg-transparent ${className ?? ''}`}
                    style={{
                        borderColor: 'transparent',
                        transition: 'border-color transparent 0.2s, outline-width 0.2s',
                        }}
                        onFocus={(e) => {
                        e.currentTarget.style.outline = `solid 2px transparent`;
                        }}
                        onBlur={(e) => {
                        e.currentTarget.style.outline = 'transparent';
                    }}
                />
                {keyboardType === 'password' && (
                    <button
                        className='text-black border-0'
                        type='button'
                        onClick={() => setShownPassword((val) => !val)}
                    >
                        {shownPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                )}
            </div>
            {touched && errorText && (
                <label className='text-red-500 text-base'>{errorText}</label>
            )}
        </div>
    )
}

export default CustomInput
